import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { getDateStringFromDate, getLocalTimeFromDatabaseTime, getMonthStringFromDate, getTimeInAMPMFromDate, getYearStringFromDate } from '../../../../catalog/DateTime';
import './css/PracticeThumbnail1.css';
import { isValidString } from '../../../../catalog/Validity';

const PracticeThumbnail1 = (props) => {
    const { id, title, venue, timeOfEvent, endTimeOfEvent } = props;

    return (
        <>
            <NavLink key={id} to={`/practice/${id}`} className="practice-thumbnail1-desktop full-width box-shadow-black curve-border-15px text-black text-no-underline m-t-10px m-b-10px">
                <div className="practice-thumbnail1-main-content full-width">
                    <div className="practice-thumbnail1-date full-width m-l-20px p-r-20px">
                        <p className="condensed-font-family m-t-0 m-l-0 m-r-0 m-b-0 font-size-l">{getMonthStringFromDate(getLocalTimeFromDatabaseTime(timeOfEvent))}</p>
                        <p className="condensed-font-family m-t-0 m-l-0 m-r-0 m-b-0 font-size-5xl">{getDateStringFromDate(getLocalTimeFromDatabaseTime(timeOfEvent))}</p>
                        <p className="condensed-font-family m-t-0 m-l-0 m-r-0 m-b-0 font-size-l">{getYearStringFromDate(getLocalTimeFromDatabaseTime(timeOfEvent))}</p>
                    </div>
                    <div className="practice-thumbnail1-content full-width m-l-20px">
                        <div className="practice-thumbnail1-title m-l-50px m-r-5px">
                            <p className="alegreya-font-family text-left-align font-size-xl m-t-0 m-b-0">
                                Practice
                            </p>
                            <p className="alegreya-font-family text-left-align font-weight-800 text-uppercase font-size-4xl curve-border-5px m-t-0 m-b-0">
                                {title}
                            </p>
                            {isValidString(venue) ? (
                                <p className="alegreya-font-family text-left-align font-size-l m-t-0 m-b-0">
                                    {`Venue: ${venue}`}
                                </p>
                            ) : null}
                        </div>
                    </div>
                </div>
                <div className="practice-thumbnail1-time-container m-l-0 m-r-20px">
                    <p className="text-right-align condensed-font-family m-t-0 m-b-0 font-size-4xl">{getTimeInAMPMFromDate(getLocalTimeFromDatabaseTime(timeOfEvent))}</p>
                    {timeOfEvent.seconds !== endTimeOfEvent.seconds ? (<p className="text-right-align condensed-font-family m-t-0 m-b-0 font-size-l">{`- ${getTimeInAMPMFromDate(getLocalTimeFromDatabaseTime(endTimeOfEvent))}`}</p>) : null}
                </div>
                <KeyboardArrowRightIcon className="practice-thumbnail1-arrow font-size-4xl m-r-20px" />
            </NavLink>
            <NavLink key={id} to={`/practice/${id}`} className="practice-thumbnail1-mobile full-width box-shadow-black curve-border-15px text-black text-no-underline m-t-10px m-b-10px">
                <div className="practice-thumbnail1-main-content p-t-40px p-b-40px">
                    <div className="practice-thumbnail1-date-time full-width m-b-30px">
                        <div className="practice-thumbnail1-date">
                            <p className="condensed-font-family m-t-0 m-l-0 m-r-0 m-b-0 font-size-s">{getMonthStringFromDate(getLocalTimeFromDatabaseTime(timeOfEvent))}</p>
                            <p className="condensed-font-family m-t-0 m-l-0 m-r-0 m-b-0 font-size-3xl">{getDateStringFromDate(getLocalTimeFromDatabaseTime(timeOfEvent))}</p>
                            <p className="condensed-font-family m-t-0 m-l-0 m-r-0 m-b-0 font-size-s">{getYearStringFromDate(getLocalTimeFromDatabaseTime(timeOfEvent))}</p>
                        </div>
                        <div className="practice-thumbnail1-time">
                            <p className="text-right-align condensed-font-family m-t-0 m-b-0 font-size-2xl">{getTimeInAMPMFromDate(getLocalTimeFromDatabaseTime(timeOfEvent))}</p>
                            {timeOfEvent.seconds !== endTimeOfEvent.seconds ? (<p className="text-right-align condensed-font-family m-t-0 m-b-0 font-size-s">{`- ${getTimeInAMPMFromDate(getLocalTimeFromDatabaseTime(endTimeOfEvent))}`}</p>) : null}
                        </div>
                    </div>
                    <div className="practice-thumbnail1-content full-width">
                        <p className="alegreya-font-family text-left-align full-width font-size-m m-t-0 m-b-5px">
                            Practice
                        </p>
                        <p className="alegreya-font-family text-left-align full-width font-weight-800 text-uppercase font-size-xl curve-border-5px m-t-5px m-b-5px">
                            {title}
                        </p>
                        {isValidString(venue) ? (
                            <p className="alegreya-font-family text-left-align full-width font-size-s m-t-5px m-b-0">
                                {`Venue: ${venue}`}
                            </p>
                        ) : null}
                    </div>
                </div>
            </NavLink>
        </>
    );
};

PracticeThumbnail1.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    venue: PropTypes.string.isRequired,
    timeOfEvent: PropTypes.object.isRequired,
    endTimeOfEvent: PropTypes.object.isRequired,
};

export default memo(PracticeThumbnail1);
